export enum ROUTES {
  ACCOUNT = "/billing",
  BILLING_MANAGEMENT = "/billing/manage",
  BILLING_LATEST_MANAGEMENT = "/billing/latest/manage",
}
